import { useToast } from '@hdmasters/vue-toast-notification'

export const $toast = useToast({ position: 'top-right' })
